<script lang="ts" setup>
import { computed } from "vue"
import { listOfReorderedTestcase } from "@/services/TestcaseHelperFunction.js"
import type {ScheduledTestCaseDTO, ScheduleDTO} from "@/types/gen";

interface Props {
    schedule: ScheduleDTO
    tests: any[]
}

const props = defineProps<Props>()
const emit = defineEmits<{
    (event: "updateSchedule", data: any): void
    (event: "saveSchedule"): void
}>()

const reorderedTestsFromSchedule = computed(() => {
    return listOfReorderedTestcase(props.tests).map((testcase: any) => {
        let testcaseFromSchedule = getTestCaseById(testcase.id)
        if (!testcaseFromSchedule) {
            const schedule = { ...props.schedule, testCases: props.schedule.testCases }
            testcaseFromSchedule = {
                testCaseId: testcase.id,
                active: false,
                maxAttempts: 1,
                minPass: 1,
                stage: 1,
            } as ScheduledTestCaseDTO
            schedule!.testCases!.push(testcaseFromSchedule)
            emit("updateSchedule", schedule)
        } else {
            Object.assign(testcaseFromSchedule, {
                maxAttempts: testcaseFromSchedule.maxAttempts || 1,
                minPass: testcaseFromSchedule.minPass || 1,
                stage: testcaseFromSchedule.stage || 1,
            })
        }
        return { ...testcase, testcaseFromSchedule }
    })
})

function saveSchedule() {
    emit("saveSchedule")
}

function getTestCaseById(testCaseId: number) {
    return props.schedule.testCases?.find((row: any) => row.testCaseId == testCaseId)
}
</script>

<template lang="pug">
.timings
    .row.schedule-tests
        .tu-small
            .tests-table
                .table-cell.heading Testcase
                .table-cell.heading.text-center.ml-2.mr-2 Active
                .table-cell.heading.text-center.ml-2.mr-2 Stop Successors
                .table-cell.heading.text-center.ml-2.mr-2 Stage
                .table-cell.heading.text-center.ml-2.mr-2 Max Attempts
                .table-cell.heading.text-center.ml-2.mr-2 Min Passed
                template(v-for="testcase in reorderedTestsFromSchedule", :key="testcase.id")
                    .table-cell.pt-2
                        router-link.tu-link(:to="`/testcase/${testcase.id}`") {{ testcase.name }}
                    .table-cell.table-cell-active.pt-2
                        .testcase-checkbox
                            label
                                input(
                                    type="checkbox",
                                    v-model="testcase.testcaseFromSchedule.active",
                                    @change="saveSchedule"
                                )
                                span
                    .table-cell.table-cell-active.pt-2
                        .testcase-checkbox
                            label(v-if="testcase.isPredecessor")
                                input(
                                    type="checkbox",
                                    v-model="testcase.testcaseFromSchedule.stopSuccessors",
                                    @change="saveSchedule"
                                )
                                span
                    .table-cell.table-cell-select
                        input.form-control(
                            type="number",
                            min="1",
                            max="99",
                            step="1",
                            style="width: 80px;",
                            v-model.number="testcase.testcaseFromSchedule.stage",
                            @change="saveSchedule"
                        )
                    .table-cell.table-cell-select
                        input.form-control(
                            type="number",
                            min="1",
                            max="99",
                            step="1",
                            style="width: 80px;",
                            v-model.number="testcase.testcaseFromSchedule.maxAttempts",
                            @change="saveSchedule"
                        )
                    .table-cell.table-cell-select
                        input.form-control(
                            type="number",
                            min="1",
                            max="99",
                            step="1",
                            style="width: 80px;",
                            v-model.number="testcase.testcaseFromSchedule.minPass",
                            @change="saveSchedule"
                        )
</template>

<style lang="css" scoped>
.schedule-tests {
    margin-top: 20px;
}

.tests-table {
    display: grid;
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(6, auto);
    width: 80vw;
}
.heading {
    font-weight: 400;
    align-self: center;
    justify-items: center;
}

.table-cell {
    margin: 0 5px 10px 5px;
}

.table-cell-active {
    align-self: center;
    justify-self: center;
}

.table-cell-select {
    justify-self: center;
}

label {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.custom-select {
    margin-left: 15px;
    margin-right: 15px;
    width: 70px;
}

.checkbox-label {
    margin-left: 15px;
}
</style>
